import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { GeoModel } from "@insite/client-framework/Types/ApiModels";

export async function getGeoApiData(apiUrl: string, apiKey: string): Promise<ServiceResult<GeoModel>> {
    const uri = `${apiUrl}&key=${apiKey}`
    const geoModel = await get<GeoModel>(uri);
    return {
        successful: true,
        result: geoModel
    };
}
